<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="create"
    max-width="600px"
    retain-focus
    v-on:click:outside="$router.push('/rawmaterial')"
    v-on:keydown.esc="$router.push('/rawmaterial')"
  >
    <v-card>
      <v-overlay absolute :value="this.loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <v-card-title tabindex="-1">
        <span class="headline">Create RawMaterial</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['RawMaterial/fetchRawMaterials']({ page: this.page });
              $router.push('/rawmaterial');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Name*"
            v-model="createFields.name"
            :rules="validationRules.name"
            :error-messages="inputErrorMessages('name')"
            name="name"
          ></v-text-field>
          <v-text-field
            label="Cost*"
            v-model="createFields.cost"
            :rules="validationRules.cost"
            :error-messages="inputErrorMessages('cost')"
            name="cost"
          ></v-text-field>
          <v-text-field
            label="Quantity/Weight*"
            v-model="createFields.quantity"
            :rules="validationRules.quantity"
            :error-messages="inputErrorMessages('quantity')"
            name="quantity"
          ></v-text-field>
          <v-select
            v-model="createFields.unit_type"
            :items="units"
            item-text="name"
            item-value="name"
            label="Unit*"
            name="unit_type"
            :rules="validationRules.unit_type"
            :error-messages="inputErrorMessages('unit_type')"
          ></v-select>
          <v-select
            v-model="createFields.supplier_id"
            :items="suppliers"
            item-text="company_name"
            item-value="id"
            label="Supplier*"
            name="supplier_id"
            :rules="validationRules.supplier_id"
            :error-messages="inputErrorMessages('supplier_id')"
          ></v-select>
          <v-list subheader>
            <v-subheader class="d-block" style="padding: 0; height: auto;"
              >Specification
              <span
                class="red--text d-block"
                v-bind:key="index"
                v-for="(message, index) in inputErrorMessages('meta')"
                >{{ message }}</span
              >
            </v-subheader>
            <v-list-item
              style="padding: 0;"
              v-for="(spec, index) in createFields.meta"
              v-bind:key="index"
            >
              <v-list-item-content>
                <v-text-field dense :label="spec.specName" v-model="spec.value"></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="primary" @click="removeSpec(index)">close</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item style="padding: 0;">
              <v-list-item-content>
                <v-text-field
                  dense
                  label="New Spec name"
                  v-model="createFields.newSpec.name"
                  :error-messages="addSpecError"
                ></v-text-field>
                <v-text-field
                  dense
                  label="New Spec value"
                  v-model="createFields.newSpec.value"
                ></v-text-field>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  color="primary"
                  @click="addSpec(createFields.newSpec.name, createFields.newSpec.value)"
                  >mdi-plus</v-icon
                >
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/rawmaterial');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveRawMaterial">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      addSpecError: undefined,
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Name'),
          v => v.length <= 255 || 'Name should not be greater than 255'
        ],
        cost: [
          v => !!v || this.rem('Cost'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Cost should be a number',
          v => v > 0 || 'Cost should be greater than 0'
        ],
        quantity: [
          v => !!v || this.rem('Quantity'),
          v =>
            (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Quantity should be a number',
          v => v > 0 || 'Quantity should be greater than 0'
        ],
        supplier_id: [v => !!v || this.rem('Supplier')],
        unit_type: [v => v != '' || this.rem('Unit')]
      },
      errorMessages: {},
      createFields: {
        name: '',
        cost: 0,
        quantity: 0,
        unit_type: '',
        supplier_id: undefined,
        meta: [],
        newSpec: {
          name: '',
          value: ''
        }
      }
    };
  },
  computed: {
    ...mapState({
      suppliers: state => state.Supplier.plainsuppliers,
      units: state => state.Unit.units
    })
  },
  mounted() {
    this['Supplier/fetchSuppliers']({ dontPaginate: false });
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['Supplier/fetchSuppliers', 'RawMaterial/fetchRawMaterials']),
    clearCreate() {
      this.createFields = {
        name: '',
        cost: 0,
        quantity: 0,
        unit_type: '',
        supplier_id: undefined,
        meta: [],
        newSpec: {
          name: '',
          value: ''
        }
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveRawMaterial() {
      if (1 == 1 || this.$refs.createForm.validate()) {
        this.loading = true;
        const formData = new FormData(this.$refs.createForm.$el);
        formData.append('meta', JSON.stringify(this.createFields.meta));
        formData.append('supplier_id', this.createFields.supplier_id);
        formData.append('unit_type', this.createFields.unit_type);
        axios
          .post('api/v1/rawmaterial', formData)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'RawMaterial created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['RawMaterial/fetchRawMaterials']({ page: this.page });
            this.clearCreate();
            if (this.continousCreation === false) {
              this.$router.push('/rawmaterial');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
           .finally(() => {
            this.loading = false;
          });
      }
    },
    removeSpec(index) {
      this.createFields.meta.splice(index, 1);
    },
    addSpec(name, value) {
      if (!!name.trim()) {
        this.createFields.meta.push({
          specName: name,
          value: value
        });
        this.addSpecError = undefined;
      } else {
        this.addSpecError = [this.rem('Specification Name')];
      }
    }
  }
};
</script>